import { render } from "./AppSpinner.vue?vue&type=template&id=a80830b0&scoped=true"
import script from "./AppSpinner.vue?vue&type=script&lang=js"
export * from "./AppSpinner.vue?vue&type=script&lang=js"

import "./AppSpinner.vue?vue&type=style&index=0&id=a80830b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a80830b0"

export default script